
import React, { useState, useEffect } from 'react'
import Swiper from 'swiper'

export default function Rotate3D(props) {
  const [ifon, setIfon] = useState({
    rotate3D: null
  })

  useEffect(() => {
    const example = new Swiper('.Rotate3D', {
      loop: true,
      autoplay: true,
      slidesPerView: 2,
      effect: 'coverflow',
      speed: props.playbackSpeed,
      centeredSlides: true,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true
      }
    })

    setIfon({
      ...ifon,
      rotate3D: example
    })

    return () => {
      example.destroy && example.destroy()
    }
  }, [])

  useEffect(() => {
    ifon.rotate3D && (ifon.rotate3D.params.speed = props.playbackSpeed)
  }, [props.playbackSpeed])

  return (<div className='Rotate3D'>
    <div class='swiper-wrapper'>
      {props.ifon.image_id_list.map((item) => {
        return <div class='swiper-slide' key={item.id}>
          <img className='slide_img' src={item.src}></img>
        </div>
      })}

    </div>
  </div>)
}
console.log(React)
